export default __webpack_public_path__ + "static/B0024-da605df9145f2b420503de9334050d7c.png";